import React, { useState } from 'react';
import { NavBar } from '..';
import { StyleSheet, css } from 'aphrodite';
import { Box, Flex } from '../Layout';
import { Close } from '../../Assets/images/svg';
import { Text } from 'ilenia';

interface HeaderProps {
    pluginVersion: string;
    source: string;
    showMenu: boolean;
    disabled: boolean;
    notify: boolean;
    mode?: string;
}

export const Header: React.SFC<HeaderProps> = (props) => {
    const { pluginVersion, source, disabled, notify, showMenu, mode } = props;
    const navBarProps = { pluginVersion, source, disabled, notify, mode };

    const renderNotification = () => {
        let reviewUsWasClosed = false;
        try {
            reviewUsWasClosed = Boolean(localStorage.getItem('tp_review_us_was_closed'));
        } catch (e) { /* empty by purpose */}
        const [reviewed, setReviewed] = useState(reviewUsWasClosed);

        const onClick = () => {
            analytics.track('Integration Link Clicked', {
                context: 'Ecommscript integration app',
                location: window.location.pathname,
                integration: source,
                placement: 'Top of the page',
                target: 'Shopify app marketplace',
                name: 'review-us-clicked',
                tierName: '',
            });
        };
        const onClose = () => {
            try {
                analytics.track('Integration Button Clicked', {
                    context: 'Ecommscript integration app',
                    location: window.location.pathname,
                    integration: source,
                    placement: 'Top of the page',
                    target: 'Shopify app marketplace',
                    name: 'review-us-closed',
                    tierName: '',
                });
                localStorage.setItem('tp_review_us_was_closed', 'true');
                setReviewed(true);
            } catch (e) { /* empty by purpose */}
        };

        if (!reviewed) {
            return (
                <div className={css(styles.box)}>
                    <Flex
                        flexDirection="row"
                        alignItems="flex-start"
                        justifyContent="start"
                    >
                        <Box mt={0} p={16}>
                            <span>
                                <Text id="Notifications.reviewUs" />
                                <a
                                    href="https://apps.shopify.com/trustpilot-reviews?#modal-show=ReviewListingModal"
                                    onClick={onClick}
                                    target="_blank"
                                >
                                    <Text id="Notifications.reviewUsLink" />
                                </a>
                            </span>
                        </Box>
                        <Box mt={0} p={16} width="auto" onClick={onClose} className={css(styles.clickable)}>
                            <Close />
                        </Box>
                    </Flex>
                </div>
            );
        }
        return null;
    };
    return (
        <>
            {source === 'Shopify' && renderNotification()}
            <header className={css(styles.header)}>
                <div  className={css(styles.logo)}/>
                {showMenu && <NavBar {...navBarProps}/>}
            </header>
        </>
    );
};

const styles = StyleSheet.create({
    logo: {
        width: '170px',
        height: '42px',
        objectFit: 'contain',
        background: 'url(//cdn.trustpilot.net/brand-assets/1.1.0/logo-black.svg) no-repeat center',
        marginBottom: '29px'
    },
    header: {
        marginBottom: '37px'
    },
    box: {
        fontFamily: 'Lato',
        fontSize: '16px',
        color: '#454554',
        backgroundColor: '#D1E0FF',
        marginBottom: '16px'
    },
    clickable: {
        ':hover': {
            cursor: 'pointer'
        },
    },
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/Header.tsx